import { appRoutes } from '../../path';

const clipboardDashboardLink = (baseId: string, instanceId?: string) =>
  window.location.origin + appRoutes.dashboard.generateLink(baseId, instanceId);

const clipboardDashboardEmbedLink = (baseId: string) =>
  window.location.origin + appRoutes.dashboard.generateEmbedLink(baseId);

export { clipboardDashboardLink, clipboardDashboardEmbedLink };
